import { Asset } from './asset.model';
import { ColorFamilyNaming } from './color-family-naming.model';
import { ColorInfoValid } from './color-info-valid.model';
import { ColorInfoType } from '../../types/color/color-info-type.type';

export class ColorDetails extends ColorInfoValid {
  readonly assets: Asset[];
  readonly lrv?: number;
  readonly ncs?: string;
  readonly colorType?: ColorInfoType;
  readonly description?: string;
  readonly colorCollections?: string[];
  readonly metaTitle?: string;
  readonly metaDescription?: string;

  constructor(
    productNumber: string,
    isFavorite: boolean,
    addedToFavoritesAt: Date | undefined,
    colorCode: string,
    colorName: string,
    rgb: string | undefined,
    image: string | undefined,
    assets: Asset[],
    isBestSeller: boolean,
    colorFamilies: ColorFamilyNaming[],
    lrv?: number,
    ncs?: string,
    colorType?: ColorInfoType,
    description?: string,
    colorCollections?: string[],
    metaTitle?: string,
    metaDescription?: string,
    brandColorCode?: string,
  ) {
    super(
      productNumber,
      isFavorite,
      addedToFavoritesAt,
      colorCode,
      colorName,
      rgb,
      image,
      isBestSeller,
      colorFamilies,
      brandColorCode,
    );
    this.assets = assets;
    this.metaTitle = metaTitle;
    this.metaDescription = metaDescription;
    this.lrv = lrv;
    this.ncs = ncs;
    this.colorType = colorType;
    this.description = description;
    this.colorCollections = colorCollections;
  }
}
